import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { ButtonContained } from '@/UI/Buttons/AppButton';
import { color } from '@/colors';
import { I18N_KEYS } from '@/language/keys';
import { AppXBtn } from '@/UI/AppXBtn/AppXBtn';
import { FlexCol } from '@/UI/styles';

type ProviderTermsDisclaimerModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const ProviderTermsDisclaimerModal = ({ open, onClose, onConfirm }: ProviderTermsDisclaimerModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      slotProps={{
        paper: {
          sx: {
            backgroundColor: color.Black92,
            backgroundImage: 'none',
            borderRadius: 2,
            border: `1px solid ${color.White08_T}`,
          },
        },
      }}
    >
      <DialogTitle component="div" sx={{ pt: '42px', pb: 3, px: 3 }}>
        <Typography variant="body-lg-sb">
          {t(I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DISCLAIMER.TITLE)}
        </Typography>
        <AppXBtn onClick={onClose} sx={{ position: 'absolute', right: 15, top: 15 }} />
      </DialogTitle>
      <DialogContent sx={{ px: 3, pt: 0, pb: 0 }}>
        <FlexCol sx={{ gap: 2 }}>
          <Typography variant="body-std-rg" sx={{ color: color.White80_T }}>
            {t(I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DISCLAIMER.HEADS_UP)}
          </Typography>
          <Typography variant="body-std-rg" sx={{ color: color.White80_T }}>
            <Trans
              i18nKey={I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DISCLAIMER.BODY}
              components={{
                bold: <Typography variant="body-std-md" component="span" sx={{ color: color.White100 }} />,
              }}
            />
          </Typography>
        </FlexCol>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, pt: 4, gap: 1 }}>
        <ButtonContained size="medium" mode="text" onClick={onClose}>
          {t(I18N_KEYS.GENERAL.CANCEL)}
        </ButtonContained>
        <ButtonContained size="medium" onClick={onConfirm}>
          {t(I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DISCLAIMER.CONTINUE)}
        </ButtonContained>
      </DialogActions>
    </Dialog>
  );
};
